import s from "../../../rc-util/es/raf.mjs";
function n(e) {
  if (typeof MessageChannel > "u")
    s(e);
  else {
    var o = new MessageChannel();
    o.port1.onmessage = function() {
      return e();
    }, o.port2.postMessage(void 0);
  }
}
export {
  n as default
};
//# sourceMappingURL=channelUpdate.mjs.map
